import React, {useEffect, useRef, useState} from 'react'
import {Checkbox, MenuProps,Tooltip,message} from 'antd';
import {Dropdown} from 'antd';
import style from './index.module.less'
import Icon, {
  CopyOutlined,
  DeleteOutlined,
  EditOutlined,
  EllipsisOutlined,
  FolderAddOutlined,
  StarOutlined
} from '@ant-design/icons';
import {noteServer} from '../../../common/notesServer'
import {
  ARRAY_DEFAULT_PROJECT_ITEM_THUMB_1, ARRAY_DEFAULT_PROJECT_ITEM_THUMB_BIG,
  DEFAULT_CANVAS_BACKGROUND,
  EVENT_FAVIRIATE_CHANGE,
  EVENT_NOTE_CHANGED,
  EVENT_NOTE_DELETE_FOREVER, EVENT_REFRESH_TAG_LSIT,
  EVENT_RESET_NO_SELECTED,
  EVENT_SHOW_DESKTOP_PRO_VIP,
  EVENT_SHOW_MESSAGE_BOX,
  FROM_HOME,
  FROM_RIGHT_SIDE,
  FROM_TAG,
  FROM_TRASH,
  MENU_SEPARATOR,
  RESPONSE_LAYOUT_L1,
  RESPONSE_LAYOUT_L2,
  VIEW_STYLE
} from "../../../Const";
import {render} from "react-dom";
import {TNote} from "../../../index";
import {
  createCopyLink, createEmptyProject,
  formatDate,
  generateRandomPageKey, generateUUID2, getImagePathSvg, getImagePathWithTheme, getImagePathWithThemeSvg,
  getItem,
  hasBeyondFreeLimit,
  imgPathPerfix, isDarkMode, isInDraw, isNoteElement
} from "../../../utils";
import {
  delNote,
  delNoteForever,
  getNoteById,
  getNoteJsonDoc,
  updateNote,
  updateNoteItemToHasUpdate
} from "../../../../model/note";
import {addEventListener, postMessage, recvMessage, triggerEvent} from "../../../common/event";
import Global from '@/global'
import {useTranslation} from "react-i18next";
import {
  IconForeverDelete, IconHiddenFromLibrary,
  IconRestore, IconVersionHistory, IconVisibleFromLibrary
} from "@/Icon";
import "./NoteItemIndex.css"
import global from "@/global";
import {getDrawPath, getFavorChildMenu, getFavorChildrenMenu, updateFavorToFolder} from "@/Utility";
import {getFavorFolderList, updateFavorFolder} from "@model/FavorFolder";
import {loopAllNode} from "@/TreeUtils";
import {getCardById} from "@model/card";
import {PROJECT_ID} from "@/views/Draw/DrawIndex";
import GridViewPropertyInfo from "@/views/Property/GridViewPropertyInfo";
import VisualThumb from "@/views/Note/NoteItem/VisualThumb";


type TNoteProps = {
  /** 是否在回收站 */
  inTrash?: boolean,
  data: TNote,
  viewStyle:VIEW_STYLE,
  searchKey?:string,
  showMoveDialog?:any,
  onAction:any,
  from?:string,
  subFrom?:string,
  isShowChecked?:boolean,
  onItemClickCallback?:any,
  itemSize?:any,
  tableView?:any,
  withPropertyHeight?:any
}

/** 笔记操作 */
export enum ENoteAction {
  /** 重命名 */
  rename,
  moveToFolder,
  /** 收藏 */
  addToFavorite,
  /** 复制 */
  makeACopy,
  managerTags,
  /** 删除 */
  delete,
  /** 恢复 */
  restore,
  /** 永久删除 */
  permancentlyDelete,
  showInfo,
  copyLink,
  search,
  changeThumbnal,
  close
}

const BORDER_RADIUS_ITEM = 8;

const Note = (props: TNoteProps) => {
  const {t} = useTranslation();
  const data = props.data
  // const navigate = useNavigate();
  const [itemWidth,setItemWidth] = useState('0px');
  const [itemTextWidth,setItemTextWidth] = useState('0px');
  const [itemHeight,setItemHeight] = useState('140px');
  const [isShowContextMenu,setIsShowContextMenu] = useState(false);
  const [isShowMoreMenu,setIsShowMoreMenu] = useState(false);
  const [isShowMoreMenu_1,setIsShowMoreMenu_1] = useState(false);
  const [isChecked,setIsChecked] = useState(false);
  const [isHovered,setIsHoverd] = useState(false);
  const [isHoverdMore,setIsHoverdMore] = useState(false);
  const [projectStats,setProjectStats] = useState('');
  const divItemRef = useRef(null);

  const createMenu = ()=>{
    if (props.isShowChecked){
      return createMultiplyMenu();
    }
    // const isFavor = data.isFavirated === 1; 图标搞得乱七八糟的东西。。。。
    const menu = props.inTrash ? [
      {
        label: t('Restore'),
        key: ENoteAction.restore,
        icon: <IconRestore/>
      },
      {
        // label:
        //   <Popconfirm
        //     title=""
        //     description="确定要永久删除吗"
        //     onConfirm={() => noteServer.deleteFovever(data.id)}
        //     okText="是"
        //     cancelText="否"
        //   >
        //     <div>
        //       <DeleteOutlined />
        //       <span style={{ marginLeft: '8px' }}>永久删除</span>

        //     </div>

        //   </Popconfirm>,
        // key: ENoteAction.permancentlyDelete,

        label: t('Delete forver'),
        key: ENoteAction.permancentlyDelete,
        icon: <IconForeverDelete/>
      },
    ] : [
      {
        label: t("Rename"),
        key: ENoteAction.rename,
        icon: <Icon component={() => <img className='img-14 mr-4' src={imgPathPerfix() + "menu_rename.png"}/>}/>
      },
      // {
      //   label: t("Move to folder"),
      //   key: ENoteAction.moveToFolder,
      //   icon: <IconMoveToFolder/>
      // },
      {
        label:data.isFavirated === 1?t('Cancel favor'):t("Add to Favorites"),
        //     <span style={{display:'inline-block'}} onClick={(event)=>{
        //   if (data.isFavirated == 0) {
        //     event.stopPropagation();
        //     setIsShowContextMenu(false);
        //     data.isFavirated = 1;
        //     data.favirateTime = new Date().getTime();
        //
        //     updateNote(data).then(res=>{
        //       postMessage(EVENT_FAVIRIATE_CHANGE);
        //       setMenuItems(createMenu());
        //     })
        //   }
        // }}>{data.isFavirated === 1?t('Cancel favor'):t("Add to Favorites")}</span>,
        key: 'favor',
        icon: data.isFavirated === 1?<Icon component={() => <img className='img-14 mr-4' src={imgPathPerfix() + "item_remove_favor.png"}/>}/>:<Icon component={() => <img className='img-14 mr-4' src={getImagePathWithTheme("add_to_favor")}/>}/>,
        children:getFavorChildrenMenu(data.isFavirated,async (key)=>{
          if (data.isFavirated == 1){
            data.isFavirated = 0;
          }else{
            data.isFavirated = 1;
          }
          data.favirateTime = new Date().getTime();
          //把这个data插入到文件夹下...
          await updateFavorToFolder(key,data);

          updateNote(data).then(res=>{
            postMessage(EVENT_FAVIRIATE_CHANGE);
            setMenuItems(createMenu());
            //刷新..
            if (res.isFavirated == 0){
              window.globalRefreshList('remove_project_by_id',res.id);
            }
          })
        }),
      },
      {
        label: t("Generic copy"),
        key: ENoteAction.makeACopy,
        icon: <Icon component={() => <img className='img-14 mr-4' src={imgPathPerfix() + "item_makecopy.png"}/>}/>
      },
      {
        label: t("Show info"),
        key: ENoteAction.showInfo,
        icon: <Icon component={() => <img className='img-14 mr-4' src={imgPathPerfix() + "context_menu_info.png"}/>}/>
      },
      getItem(<div className={'ml-4'}>{t("Version history")}<label className={'beta'}>{'Beta'}</label></div>, 'versionHistory', <IconVersionHistory/>, undefined, undefined, () => {
        //历史记录
        window.showDialogProjectHistory(props.data.id, (newProject: any) => {

        });
      }),
      {
        label: t("Change thumbnail"),
        key: ENoteAction.changeThumbnal,
        icon: <Icon component={() => <img className='img-14 mr-4' src={imgPathPerfix() + "context_menu_changethumbnail.png"}/>}/>
      },

      {
        label: data.isHidden == 1?t("MakeThisProjectVisible"):t("Hide project"),
        key: 'hiddenVisibleFromProject',
        // icon: data.isHidden == 1?<IconVisibleFromLibrary/>:<IconHiddenFromLibrary/>,
        icon: <Icon component={() => <img className='img-14 mr-4' src={imgPathPerfix() + (data.isHidden == 1?"contextmenu_make_visible_from_library.png":'contextmenu_hidden_from_library.png')}/>}/>
      },

      getItem(MENU_SEPARATOR, generateUUID2(), null, undefined, 'divider', () => {

      }),
      {
        label: t("Copy link"),
        key: ENoteAction.copyLink,
        icon: <Icon component={() => <img className='img-14 mr-4' src={imgPathPerfix() + "context_menu_link.png"}/>}/>
      },
      {
        label: t("Manage tags"),
        key: ENoteAction.managerTags,
        icon: <Icon component={() => <img className='img-14 mr-4' src={imgPathPerfix() + "item_manage_tag.png"}/>}/>
      },

      getItem(MENU_SEPARATOR, generateUUID2(), null, undefined, 'divider', () => {

      }),

      {
        label: t("Delete"),
        key: ENoteAction.delete,
        icon: <Icon component={() => <img className='img-14 mr-4' src={imgPathPerfix() + "item_delete.png"}/>}/>
      }
    ]

    return menu;
  }

  /**
   * 多选菜单
   */
  const createMultiplyMenu = ()=>{
    const arrayMenus = [
      {
        label: t("Manage tags"),
        key: 'managerTagsMultiply',
        icon: <Icon component={() => <img className='img-14 mr-4' src={imgPathPerfix() + "item_manage_tag.png"}/>}/>
      },
      {
        label: t("Delete"),
        key: 'deleteMultiply',
        icon: <Icon component={() => <img className='img-14 mr-4' src={imgPathPerfix() + "item_delete.png"}/>}/>
      }
    ]
    return arrayMenus;
  }
  const [menuItems,setMenuItems] = useState<MenuProps['items']>(createMenu());

  const handleMenuClick = async (e: any) => {
    if (e.key == 'managerTagsMultiply'){
      props.onAction('managerTagsMultiply');
      return;
    }else if (e.key == 'deleteMultiply'){
      props.onAction('deleteMultiply');
      return;
    }
    let key: any = +e.key as ENoteAction
    if (e.key == 'favor'){
      key = 'favor'
    }else if (e.key == 'hiddenVisibleFromProject'){
      key = 'hiddenVisibleFromProject';
    }
    switch (key) {
      case ENoteAction.restore:
        // noteServer.restore(data.id)
          if (await hasBeyondFreeLimit()){
            postMessage(EVENT_SHOW_DESKTOP_PRO_VIP,{from:''});
            return;
          }
          data.isFavirated = 0;
          data.isDeleted = 0;
          data.updateTime = new Date().getTime();
          updateNote(data).then(res=>{
            postMessage(EVENT_NOTE_CHANGED);
            //刷新回收站
            // postMessage(EVENT_NOTE_DELETE_FOREVER)
            if (window.refreshTrash){
              window.refreshTrash();
            }
          })
        break;
      case ENoteAction.addToFavorite:
      case 'favor':
        // noteServer.favitateNote(data.id)
          if (data.isFavirated == 1){
            data.isFavirated = 0;
          }else{
            data.isFavirated = 1;
          }
          // data.isFavirated = !data.isFavirated;
          data.favirateTime = new Date().getTime();
          updateNote(data).then(res=>{
            postMessage(EVENT_FAVIRIATE_CHANGE);
            setMenuItems(createMenu());
            //刷新..
            if (res.isFavirated == 0){
              window.globalRefreshList('remove_project_by_id_in_favor',res.id);
            }
          })
        break;
      case ENoteAction.makeACopy:
        // noteServer.copy(data.id)
        if (await hasBeyondFreeLimit()){
          postMessage(EVENT_SHOW_DESKTOP_PRO_VIP,{from:''});
          return;
        }
        var noteCopy = {...data};
        noteCopy.id = generateRandomPageKey();
        noteCopy.name = noteCopy.showName = noteCopy.name+`(${t("Copy")})`;
        noteCopy.updateTime = new Date().getTime();
        noteCopy.createTime = Date.now();
        noteCopy.isFavirated = 0;
        const dbNote = await getNoteById(data.id);
        noteCopy.doc = dbNote?.doc;
        updateNoteItemToHasUpdate(noteCopy);
        updateNote(noteCopy).then(res=>{
          postMessage(EVENT_NOTE_CHANGED);
        })
        break;
      case ENoteAction.rename:
        noteServer.rename(data)
        break;
      case ENoteAction.delete:
        // const deleteRet = await confirmServer.open(t("Confirm delete"), t("Delete note can view trash"), t("Delete"))
        // if (deleteRet) {
        //   // noteServer.deleteNote(data.id)
        //   delNote(data);
        // }
          window.showMessageBox(t("Confirm delete"),t("Delete note can view trash"),t("Cancel"),t("Delete"),null,()=>{
            delNote(data).then(res=>{
              postMessage(EVENT_REFRESH_TAG_LSIT);
              postMessage(EVENT_NOTE_CHANGED);
            });
          })
        // postMessage(EVENT_SHOW_MESSAGE_BOX,data);
        break;
      case ENoteAction.permancentlyDelete:
        // const deleteRet2 = await confirmServer.open(t("Confirm delete forver"), t("Delete forver cant restore"), t("Delete forver"))
        // if (deleteRet2) {
        //   // noteServer.deleteFovever(data.id)
        //   delNoteForever(data.id);
        // }
        window.showMessageBox(t("Confirm delete forver"),t("Delete forver cant restore"),t("Cancel"),t("Delete forver"),null,()=>{
          delNoteForever(data.id);
        })
        break;
      case ENoteAction.moveToFolder:
        // dialogMovetoFolderRef?.current.onShowDialogEvent(data);
          props.showMoveDialog(data);
        break;
      case ENoteAction.managerTags:
        props.onAction("managerTags",data);
        break;
      case ENoteAction.showInfo:
        getNoteById(data.id,false).then(res=>{
          window.showInfo('project',res);
        })
        break;
      case ENoteAction.copyLink:
        createCopyLink('project',data.id)
        break;
      case ENoteAction.changeThumbnal:
        props.onAction("changeThumbnail",data);
        break;
      case "hiddenVisibleFromProject":
        if (data.isHidden == 1){
          data.isHidden = 0;
        }else{
          data.isHidden = 1;
        }
        updateNote(data).then(res=>{
          if (data.isHidden == 0){
            //隐藏
            window.globalRefreshList('remove_project_by_id',res.id);
          }else{
            //显示的话就刷新全部...
            window['refresh_project_list']();
          }
        })
        break;
    }
  };

  // window.onmessage = (event)=>{
  //   if(event.data.eventName == EVENT_FAVIRIATE_CHANGE){
  //
  //   }
  // }

  useEffect(()=>{
    setIsHoverd(false);

    recvMessage(EVENT_FAVIRIATE_CHANGE,(msg,data)=>{
      // setMenuItems(createMenu());
    })

    resizeWindow();

    const resizeObserver = new ResizeObserver(entries => {
      resizeWindow();
    })
    if (divItemRef.current){
      resizeObserver.observe(divItemRef.current);
    }

    window.addEventListener("resize",resizeWindow)
    return()=>{
      window.removeEventListener('resize',resizeWindow);
    }
  },[]);

  useEffect(() => {
    if (props.data){
      //这里统计画板和卡片数量
      getNoteJsonDoc(props.data.id).then(res=>{
        let nBoardCount = 0;
        let nCardsCount = 0;
        if (res){
          loopAllNode(res.canvas,(item)=>{
            if (!item.isFolder && item.drawJson?.elements){
              nBoardCount ++;
              // nCardsCount += item.drawJson.elements.filter(p=>isNoteElement(p)).length;//这里 不同的画板里面可能会有重复的node....
            }
          })
          nCardsCount = res.notes.length;

          // nBoardCount = res.canvas.length;
          // res.canvas.forEach(p=>{
          //   nCardsCount += p.drawJson.elements.filter(p=>isNoteElement(p)).length;
          // })
        }
        setProjectStats(`${t("Boards")}: ${nBoardCount}　${t("Cards")}: ${nCardsCount}`)
      })
    }
  }, [props.data]);

  useEffect(() => {
    if (props.itemSize){
      setItemWidth(props.itemSize.width+'px');
      setItemHeight(props.itemSize.height+'px');
    }
  }, [props.itemSize]);

  useEffect(() => {
    setIsChecked(props.data.isChecked);
  },[props.data.isChecked]);

  useEffect(() => {
    if (!props.isShowChecked){
      setIsHoverd(false);
    }
  }, [props.isShowChecked]);

  function resizeWindow(){
    if (props.from == FROM_RIGHT_SIDE)return;

    const margin = 11;
    let nItemCount = 4;
    if (props.from == FROM_TAG || props.from == FROM_TRASH){
      nItemCount = 5;
    }else if (props.from == FROM_HOME){
      let nDocumentWidth = document.body.clientWidth;
      if (nDocumentWidth < RESPONSE_LAYOUT_L1){
        nItemCount = 4;
      }else if (nDocumentWidth < RESPONSE_LAYOUT_L2){
        nItemCount = 5;
      }else{
        nItemCount = 6;
      }
    }
    global.g_home_project_count = nItemCount;

    // var item = document.getElementById("#divList");
    //左边菜单240 -- 间距margin左右各20  每个item的间距 8
    let nWidth = divItemRef.current?.clientWidth;//(document.body.clientWidth-241-(nItemCount-1)*(32) - 32)/nItemCount - 4;
    let nHeight = nWidth*9/16;
    if (props.from == FROM_TAG || props.from == FROM_TRASH){
      // const nWidth = (document.body.clientWidth-241-(5)*(8*2) - 30)/nItemCount;
      // nHeight = nWidth*0.76;
    }else if (props.from == FROM_HOME){
      // let nItemWidth = divItemRef?.current?.clientWidth;
      // console.log(nWidth)
      nHeight = nWidth *0.68 ;
    }
    nHeight = nWidth *0.68 ;

    setItemTextWidth((nWidth - 16)+'px');
    setItemWidth(nWidth+'px');
    setItemHeight(nHeight+'px');
  }

  /**
   * 转到编辑
   */
  const navNoteEdit = async ()=>{
    let newData = data;
    if (newData.id == 'newProject'){
      if (await hasBeyondFreeLimit()){
        postMessage(EVENT_SHOW_DESKTOP_PRO_VIP,{from:''})
        return;
      }
      newData = createEmptyProject(generateUUID2(),'');
      await updateNote(newData);
    }
    if (newData.isDeleted === 1) return;
    if (props.subFrom == FROM_RIGHT_SIDE){
      if (isInDraw() && newData.id == PROJECT_ID){
        message.destroy();
        message.error(t('ProjectAlreadyInUse'));
        return;
      }
      props.onItemClickCallback(newData);
    }else{
      postMessage(EVENT_RESET_NO_SELECTED);
      window.navigateOrigin(getDrawPath(),{state:{noteData:newData,searchKey:props.searchKey}});
    }
    // navigate('/draw/'+data.id);
    // navigate('/draw/'+data.id+"/n/bfc0dd7c-dc38-2cb6-0d89-980003bbefa4");
  }

  const getImageSrc = (data)=>{
    if (data.thumbUrl){
      if (data.thumbUrl.startsWith('localfile://')){
        return data.thumbUrl;
      }
      //旧的全部换成新的.
      let nOldIndex = ARRAY_DEFAULT_PROJECT_ITEM_THUMB_1.findIndex(p=>data.thumbUrl.includes(p));
      if (nOldIndex != -1){
        if (nOldIndex >= ARRAY_DEFAULT_PROJECT_ITEM_THUMB_BIG.length){
          nOldIndex = 0;
        }
        data.thumbUrl = ARRAY_DEFAULT_PROJECT_ITEM_THUMB_BIG[nOldIndex];
      }
      return imgPathPerfix()+(isDarkMode()?data.thumbUrl.replace('.png','_white.png'):data.thumbUrl);
    }
    return data.img;
  }

  const isCustomImage = (data)=>{
    if (data.thumbUrl == 'init_info_0.png'){
      return true;
    }
    if (data.thumbUrl){
      if (data.thumbUrl.startsWith('localfile://')){
        return true;
      }
      return false;
    }
    return true;
  }

  /**
   * 主是要菜单favor的点击...有二级菜单的情况下，一级是不响应的.
   */
  const patchMenuFavor = ()=>{
    setTimeout(()=>{
      const arrayMenus = document.getElementsByClassName('ant-dropdown-menu-submenu-title');
      for (let i=0;i<arrayMenus.length;i++){
        const item = arrayMenus[i];
        if (item.dataset?.menuId?.endsWith('-favor')){
          item.onclick = function (event:any){
            //这里是添加到根
            handleMenuClick({key:'favor'});
            setIsShowContextMenu(false);
            setIsShowMoreMenu(false);
            setIsShowMoreMenu_1(false);
          }
        }
      }
    },100)
  }

  const getItemHeight = ()=>{
    if (props.withPropertyHeight){
      return props.withPropertyHeight+'px';
    }
    return props.from == FROM_TAG?'calc(100% - 16px)':'auto';
  }

  const renderGridView =()=> {
    return (
        // style={{width:itemWidth,height:itemHeight}}
        <Dropdown overlayClassName='default-dropdown-style' open={isShowContextMenu} menu={{ items:menuItems ,onClick: handleMenuClick}} trigger={['contextMenu']}
                  onOpenChange={async (e)=>{
                    // if (props.from == FROM_TAG) {
                    //   setIsShowContextMenu(false);
                    //   return;
                    // }
          if (e){
            //更新收藏状态
            const dbNote:TNote = await getNoteById(props.data.id,false) as TNote;
            if (dbNote) {
              props.data.isFavirated = dbNote.isFavirated;
            }
            setMenuItems(createMenu);

            patchMenuFavor();
          }
          setIsShowContextMenu(e);
        }}>
          <div ref={divItemRef} data-id={props.data?.id} className={style.NoteStyle + ' carditem hovered-some-image'} style={{
            margin: props.from == FROM_TAG?'8px':'0px 0px',
            height:getItemHeight(),
            display: "flex",
            flexDirection: 'column',
            position:'relative',
            // borderRadius:'12px',
            overflow:props.from == FROM_TAG?'':'hidden',
            cursor:'pointer',
            width:'auto',//props.subFrom == FROM_RIGHT_SIDE?itemWidth:'auto',
            visibility: props.data.id === '-1' ? 'hidden' : 'visible'}} onMouseEnter={()=>{
              setIsHoverd(true)
          }} onMouseLeave={()=>{
            setIsHoverd(false);
          }}>
            <div className={style.imgView + ' div-item-container'} onClick={async () => {
              if (props.isShowChecked) {
                props.data.isChecked = !isChecked;
                setIsChecked(!isChecked);
                if (props.onAction){
                  props.onAction('onChecked');
                }
              }else {
                navNoteEdit();
              }
            }} style={{
              borderTop:'1px solid var(--border-color)',
              borderLeft:'1px solid var(--border-color)',
              borderRight:'1px solid var(--border-color)',
              borderBottom:`${props.from == FROM_HOME?1:0}px solid var(--border-color)`,
              height: itemHeight,
              // backgroundColor:'var(--home-item-background-color-new)',//#F1F1F1
              borderRadius: props.from != FROM_HOME?'8px 8px 0 0':'8px',
              overflow:'hidden',
              position:'relative',
              flexShrink:'0'
              // border: props.data.isChecked?'1px solid var(--link-color)':'0px solid var(--border-color)',
            }}>

              <div className={' flex-column-center'} style={{zIndex:'12',height: itemHeight,width:'100%',
                overflow:'hidden',borderRadius:props.from != FROM_HOME?`${BORDER_RADIUS_ITEM+1}px ${BORDER_RADIUS_ITEM+1}px 0 0`:`${BORDER_RADIUS_ITEM+1}px`,margin:'0px',padding:isCustomImage(data)?'0px':'0px',}}>

                {
                  (isCustomImage(data) || props.data.id == 'newProject') ? <img src={getImageSrc(data)} alt=""
                                             style={{
                                               width: props.data.id == 'newProject' ? '16px' : '100%',
                                               height: props.data.id == 'newProject' ? '16px' : '100%',
                                               objectFit: isCustomImage(data) ? 'cover' : 'contain',
                                               borderRadius: '8px 8px 0 0',
                                               overflow: 'hidden'
                                             }}/>:<VisualThumb from={props.from} marginBottom={props.from == FROM_HOME ? 52 : 0} data={data} randomKey={generateUUID2()}/>
                }

                {
                    props.data.id == 'newProject' &&
                    <span className={'default-font-size'} style={{marginTop: '8px', color: 'var(--text-color-66666)'}}>{t("New project")}</span>
                }
              </div>

              {/*<div className={style.fn}>*/}
              {/*  <div onClick={(e) => e.stopPropagation()}>*/}
              {/*    {*/}
              {/*        props.from != FROM_TAG &&*/}
              {/*        <Dropdown menu={{items: menuItems, onClick: handleMenuClick}}>*/}
              {/*          <EllipsisOutlined className={style.moreIcon}/>*/}
              {/*        </Dropdown>*/}
              {/*    }*/}
              {/*  </div>*/}
              {/*</div>*/}

              {
                props.data.id != 'newProject' &&
                <div style={{position: "absolute", top: '8px', right: '8px',/*visibility:isHovered?'visible':'hidden',*/zIndex:'99'}}
                     onMouseEnter={()=>setIsHoverdMore(true)} onMouseLeave={()=>setIsHoverdMore(false)}
                     onClick={(event) => {
                  event.stopPropagation();
                  setIsShowContextMenu(false);
                }}>
                  {
                      (props.from !== FROM_TRASH) &&
                    <Tooltip arrow={false} title={t("Change thumbnail")}>
                      <img className={'img-24 link-open'} src={getImagePathWithThemeSvg('home_item_change_thumb')} onClick={()=>{
                        props.onAction("changeThumbnail",data);
                      }}/>
                    </Tooltip>
                  }

                  {
                      (props.from !== FROM_TRASH) &&
                      <Tooltip arrow={false} title={t("Info")}>
                        <img className={'img-24 ml-8 link-open'} src={getImagePathWithThemeSvg('library_info')} onClick={()=>{
                          getNoteById(data.id,false).then(res=>{
                            window.showInfo('project',res);
                          })
                        }}/>
                      </Tooltip>
                  }

                  <Dropdown trigger={['click']} open={isShowMoreMenu_1} onOpenChange={(e)=>{
                    //要改菜单的地方太多了。DYAMIC
                    setMenuItems(createMenu());
                    setIsShowMoreMenu_1(e);
                    patchMenuFavor();
                  }} menu={{items: menuItems, onClick: handleMenuClick}}>
                    <Tooltip arrow={false} title={t("More")}>
                      <img className={'img-24 ml-8 link-open'} src={getImagePathWithThemeSvg((isHoverdMore?'library_more':"library_more"))}/>
                    </Tooltip>
                  </Dropdown>
                </div>
              }

              {
                //下半部分的标题和项目信息统计
                  (props.from !== FROM_TAG && props.from !== FROM_TRASH && props.data.id != 'newProject'/*&& props.subFrom != FROM_RIGHT_SIDE*/) &&
                  <div style={{position:'absolute',bottom:'0',overflow:'hidden',
                    background:'var(--home-item-project-info-background-color)',width:'100%',minHeight:'52px',
                    padding:'0 12px',
                    display:'flex',
                    flexDirection:'column',
                    justifyContent:'center',
                    zIndex:'101',
                    borderTop:'0px solid var(--line-color)',}}>
                    <span className='span-single-line font-size-12 default-font-family font-family-medium' style={{
                      width: props.subFrom == FROM_RIGHT_SIDE ? 'auto' : itemTextWidth,
                    }}>{data.name || t("Untitled")}</span>
                    <span　className={'mt-2'} style={{fontSize:'10px',color:'var(--color-666666)'}}>{projectStats}</span>
                  </div>
              }
            </div>


            {
                props.subFrom == FROM_RIGHT_SIDE && props.data.id !== 'newProject' &&
                <span className={'flex-center span-single-line'} style={{
                  position: 'absolute',
                  bottom: '0px',
                  fontSize: '13px',
                  height: '30px',
                  width: 'calc(100% - 1px)',
                  lineHeight: '30px',
                  color: 'white',
                  padding: '0 12px',
                  display: 'block',
                  overflow: 'hidden',
                  left:'1px',
                  borderRadius:'0 0 12px 12px',
                  background: 'rgba(0,0,0,.55)'
                }}>{data.name}</span>
            }

            {
                props.isShowChecked &&
                <>
                  <Checkbox checked={isChecked} style={{position: "absolute", right: '12px', top: '6px', zIndex: '99'}}
                            onClick={(event) => {
                              setIsChecked(!isChecked);
                              props.data.isChecked = !isChecked;
                              // props.onCheckedCallback(props.data);
                            }}/>
                </>
            }

            {
              (props.from == FROM_TRASH || (props.tableView && props.tableView.columns.length == 0)) && false &&
              <span className={'flex-center span-single-line'} style={{
                position: 'absolute', bottom: '0px',
                borderRadius:'0 0px 8px 8px',
                right:'0px',
                zIndex:'100',
                height: '30px', background: 'rgba(0,0,0,.66)', width: '100%', lineHeight: '30px',
                color: 'white', padding: '0 12px', display: 'block', overflow: 'hidden'
              }}>{props.data.name}</span>
            }

            {
                props.from != FROM_HOME &&
                <>
                  <div className={'line'} style={{width:'100%'}}></div>
                  <GridViewPropertyInfo tableView={props.tableView} item={props.data}/>
                </>
            }

            <div className={'hovered-home-border'} style={{position:'absolute',
              top:'0',left:'0',width:'100%',height:'100%',
              pointerEvents:'none',
              border:(isHovered || props.data.isChecked)?'1.3px solid var(--primary-color)':'1.3px solid var(--line-color)'}}>

            </div>
          </div>
        </Dropdown>
    )
  }

  const renderListView = ()=>{
    return(
        <Dropdown overlayClassName='default-dropdown-style' open={isShowContextMenu} menu={{ items:menuItems ,onClick: handleMenuClick}} trigger={['contextMenu']} onOpenChange={async (e)=>{
          if (e){
            //更新收藏状态
            const dbNote:TNote = await getNoteById(props.data.id,false) as TNote;
            if (dbNote) {
              props.data.isFavirated = dbNote.isFavirated;
            }
            setMenuItems(createMenu);
          }
          setIsShowContextMenu(e);
        }}>
          <div className='list-item-hover ' style={{width:'100%',height:'99px',
            position:'relative',
            margin:'5px 0px',display:'flex',alignItems:'center',
            visibility:props.data.id==='-1'?'hidden':'visible'}} onClick={()=>navNoteEdit()}>

            <img src={getImageSrc(data)} alt=""
                 style={{width:'154px',height:'100px',
                   border: '1px solid var(--input-border-color)',
                   backgroundColor:'var(--home-item-background-color)',
                   borderRadius: '12px',
                   flexShrink:'0',
                   objectFit:isCustomImage(data)?'cover':'cover'}}/>

            {/*<div alt="" className={style.imgCenterCrop} style={{width: '120px',height:'100%',border:'1px solid #efefef',background:'url('+data.img+')',backgroundSize:'100%',backgroundPosition:'center'}}></div>*/}
            <div className={style.name} style={{margin:'0 16px',flexGrow:'1',display:"flex",alignItems:'flex-start'}}>
              <span className={'default-font-size'} style={{textOverflow:'ellipsis',maxHeight:'3em',overflow:'hidden',lineHeight:'1.5em',}}>{data.name || t("Untitled")}</span>
            </div>

            {
              props.from != FROM_TAG &&
                <div className='list-conent-right'>
                  <span className={'w-cell-item align-left'} style={{width:'200px'}}>{projectStats}</span>
                  <span
                      className='w-cell-item align-left'>{formatDate(data.updateTime, Global.g_dateFormat + ' hh:mm')}</span>
                  <span
                      className='w-cell-item align-left ml-item_margin'>{formatDate(data.createTime, Global.g_dateFormat + ' hh:mm')}</span>
                  <div className={"w-cell-item-more ml-item_margin " + style.fn}>
                    <div onClick={(e) => e.stopPropagation()}>
                      <Dropdown open={isShowMoreMenu} onOpenChange={(e) => {
                        setIsShowMoreMenu(e);
                        patchMenuFavor();
                      }} menu={{items: menuItems, onClick: handleMenuClick}}>
                        <img style={{width: '12px', height: '12px'}} src={getImagePathWithTheme("more_horizontal")}/>
                      </Dropdown>
                    </div>
                  </div>
                </div>
            }

          </div>
        </Dropdown>
    )
  }

  if (props.viewStyle == VIEW_STYLE.VIEW_STYLE_GRID) {
    //grid view
    return renderGridView();
  } else if (props.viewStyle == VIEW_STYLE.VIEW_STYLE_LIST) {
    //list view
    return renderListView();
  }

}
export default React.memo(Note,(prevProps,nextProps)=>{
  return false;
})

















